import * as TYPE from './actionType.js';

export function masterData(masterData) {
  return { type: TYPE.MASTERDATA, data: masterData };
}
